import _ from 'lodash';
var Cart = {};

Cart.install = function(Vue) {
  var cartKeys = function() {
    var allKeys = Object.keys(window.localStorage)
    return _.filter(allKeys, function(key) {
      if (key.includes("symbium_cart_")) { return key; }
    })
  };
  var products = [
    'Symbium Build', 'Symbium Build+', 'Symbium Build Business'
  ];

  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumSignificantDigits: 3
  });

  Vue.prototype.$products = products;
  Vue.prototype.$cart = {
    loadCart() {
      return _.map(cartKeys(), function(key) {
        return window.localStorage.getItem(key)
      })
    },
    clearCart() {
      return _.each(cartKeys(), function(key) {
        window.localStorage.removeItem(key)
      })
    },
    isEmpty() {
      return this.loadCart().length == 0;
    },
    hasDataProduct() {
      return _.intersection(products.slice(0,2), this.loadCart()).length > 0;
    },
    setCheckOutCart() {
      window.localStorage.setItem('symbium_checkout_cart', JSON.stringify(this.loadCart()));
    },
    getCheckOutCart() {
       return JSON.parse(window.localStorage.getItem('symbium_checkout_cart'));
    },
    addItem(item) {
      var keys = cartKeys();
      var stop = false
      _.each(keys, function(key) {
        var storedItem = window.localStorage.getItem(key);
        if (storedItem == item) { stop = true }
      });

      if(stop) return;

      var lastKey = _.max(keys);
      var lastIndex = lastKey ? parseInt(lastKey.split('_')[2]) : -1;
      window.localStorage.setItem("symbium_cart_" + (lastIndex + 1).toString(), item);
    },
    removeItem(item) {
      _.each(cartKeys(), function(key) {
        var storedItem = window.localStorage.getItem(key);
        if (storedItem == item) { window.localStorage.removeItem(key); }
      })
    },
    isBuildPlus(item) {
      return item == products[1];
    },
    isBuild(item) {
      return item == products[0];
    },
    itemCostValue(item, questionnaire) {
      if(this.isBuildPlus(item)) {
        var items = questionnaire.getAnswer('numberOfAccounts').value || 1;
        var addtion = _.max([0, items - 5]);
        return 5000 + ( addtion * 500 );
      } else {
        return 20000;
      }
    },
    itemCost(item, questionnaire) {
      return formatter.format(this.itemCostValue(item, questionnaire));
    },
    annualCost(questionnaire, discount) {
      var items = this.loadCart();
      if (items.length == 0) return '$—';
      var cost = _.sumBy(items, (item) => this.itemCostValue(item, questionnaire));
      if(discount) {
        cost = cost - discount;
      }
      if(cost || cost == 0) {
        return formatter.format(cost);
      }

      return '$—';
    },
    annualCostInUsd(questionnaire) {
      return _.sumBy(this.loadCart(), (item) => this.itemCostValue(item, questionnaire));
    },
    estimatedTime(questionnaire) {
      var estimated = '—';
      if (questionnaire.isGovernment()) {
        var carts = this.loadCart();
        if (carts.length == 1 || (carts.length == 2 && carts.indexOf(products[2]) == -1)) {
          switch (questionnaire.getAnswer('organizationSize').value) {
            case '0':
              estimated = '2 - 5 weeks'
              break;
            case '1':
              estimated = '5 - 9 weeks'
              break;
            case '2':
              estimated = '9 - 13 weeks'
              break;
            default:
              break;
          }
        } else if (carts.length == 3 || (carts.length == 2 && carts.indexOf(products[2]) > -1)) {
          switch (questionnaire.getAnswer('organizationSize').value) {
            case '0':
              estimated = '4 - 10 weeks'
              break;
            case '1':
              estimated = '10 - 18 weeks'
              break;
            case '2':
              estimated = '18 - 26 weeks'
              break;
            default:
              break;
          }
        }
      }

      return estimated;
    },
    availableItems(questionnaire) {
      var currentCart = this.loadCart();
      if(questionnaire.isGovernment()) {
        return [
          {
            name: products[0],
            text: 'Empower residents with automatic ADU eligibility and development standards. ',
            linkText: 'Learn more',
            addedToCart: currentCart.indexOf(products[0]) > -1,
            href: 'https://www.symbium.com/build',
          },
          {
            name: products[1],
            text: 'Region-to-Parcel Analysis of jurisdictions. Visualize the regulations and data that inform development. ',
            linkText: 'Learn more',
            addedToCart: currentCart.indexOf(products[1]) > -1,
            href: 'https://www.symbium.com/buildplus',
          },
          {
            name: products[2],
            text: 'See where particular businesses are allowed in your city. ',
            linkText: 'Learn more',
            addedToCart: currentCart.indexOf(products[2]) > -1,
            href: 'https://www.symbium.com/buildbusiness',
          },
        ]
      } else {
        return [
          {
            name: products[1],
            text: 'Region-to-Parcel Analysis of jurisdictions. Visualize the regulations and data that inform development. ',
            linkText: 'Learn more',
            addedToCart: currentCart.indexOf(products[1]) > -1,
            href: 'https://www.symbium.com/buildplus',
          },
        ]
      }
    }
  }
};

export default Cart;
